import { render, staticRenderFns } from "./ScanBear.vue?vue&type=template&id=8f2c1858&scoped=true&"
import script from "./ScanBear.vue?vue&type=script&lang=js&"
export * from "./ScanBear.vue?vue&type=script&lang=js&"
import style0 from "./ScanBear.vue?vue&type=style&index=0&id=8f2c1858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2c1858",
  null
  
)

export default component.exports